/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowBoldRight: {
  name: 'arrow-bold-right';
  data: string;
} = {
  name: 'arrow-bold-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.788 2.547a.5.5 0 0 1 .532.069l6 5a.5.5 0 0 1 0 .768l-6 5A.5.5 0 0 1 8.5 13v-2.5H2A1.5 1.5 0 0 1 .5 9V7A1.5 1.5 0 0 1 2 5.5h6.5V3a.5.5 0 0 1 .288-.453Zm.712 1.52V6a.5.5 0 0 1-.5.5H2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h7a.5.5 0 0 1 .5.5v1.932L14.219 8 9.5 4.068Z" fill="currentColor"/></svg>`,
};
